import { AllocationData } from '@/app/models/avaliablePercent';
import { useListAllGroupedAvaliablePercentQuery } from '@/app/services/avaliablePercetApi';
import AvaliablePercentageTable from '@/components/AvailablePercentage/AvaliablePercentageTable';
import NewEditValuePercent from '@/components/AvailablePercentage/percentageAvaliableEditScreen/NewEditValuePercent';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import TextButton from '@/components/common/TextButton';
import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function AvaliablePercentage() {
  const { t } = useTranslation('avaliablePercentage');
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState<AllocationData | null>(null);
  const { data } = useListAllGroupedAvaliablePercentQuery();
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <PageTitle
        title={t('percentage.available')}
        titleLabel={` (${t('general.rule')})`}
        subtitle={`${t('rule.allocation.percentage')}`}
      />
      <TextButton
        sx={{ ml: 'auto' }}
        text={`+ ${t('new.percentage')}`}
        onClick={() => {
          setSelectedItem(null);
          setDrawerStatus(true);
        }}
      />
      <AvaliablePercentageTable setSelectedItem={setSelectedItem} setDrawerOpen={setDrawerStatus} rows={data || []} />
      <LateralDrawer open={drawerStatus} setOpen={setDrawerStatus} position="right" width={theme.spacing(75)}>
        <NewEditValuePercent editBranchCode={selectedItem?.branchCode} setDrawerOpen={setDrawerStatus} />
      </LateralDrawer>
    </Box>
  );
}
export default AvaliablePercentage;
